import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 13.333 13.333"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #8C8F97)",
      d: "M6.667 13.333A6.666 6.666 0 1 1 6.667 0a6.666 6.666 0 0 1 0 13.333m0-1.333a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667m.666-5.333H10V8H6V3.333h1.333z"
    }, null, -1)
  ]))]))
}
export default { render: render }